// Generated from the shared app source. Do not edit.
/* eslint-disable no-whitespace-before-property */






export function assertCivilDate(date           )       {
  if (!Number.isInteger(date.year) || date.year < 1 || date.year > 9999) {
    throw new RangeError('Year must be an integer between 1 and 9999.');
  }

  if (!Number.isInteger(date.month) || date.month < 1 || date.month > 12) {
    throw new RangeError('Month must be an integer between 1 and 12.');
  }

  const maximumDay = daysInMonth(date.year, date.month);
  if (!Number.isInteger(date.day) || date.day < 1 || date.day > maximumDay) {
    throw new RangeError(`Day must be an integer between 1 and ${maximumDay}.`);
  }
}

export function daysInMonth(year        , month        )         {
  if (!Number.isInteger(year) || !Number.isInteger(month)) {
    throw new RangeError('Year and month must be integers.');
  }

  if (month < 1 || month > 12) {
    throw new RangeError('Month must be an integer between 1 and 12.');
  }

  if (month === 2) {
    return isLeapYear(year) ? 29 : 28;
  }

  return [4, 6, 9, 11].includes(month) ? 30 : 31;
}

export function isLeapYear(year        )          {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}

export function calculateAge(birthDate           , asOfDate           )         {
  assertCivilDate(birthDate);
  assertCivilDate(asOfDate);

  if (compareCivilDates(asOfDate, birthDate) < 0) {
    throw new RangeError('Reference date cannot be earlier than birth date.');
  }

  const birthdayHasOccurred =
    asOfDate.month > birthDate.month ||
    (asOfDate.month === birthDate.month && asOfDate.day >= birthDate.day);

  return asOfDate.year - birthDate.year - (birthdayHasOccurred ? 0 : 1);
}

function compareCivilDates(left           , right           )         {
  return left.year - right.year || left.month - right.month || left.day - right.day;
}
